import * as types from "./mutation-type";
import { getCalendarEventsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";
const actions = {
  async getCalendarEvents({ commit }, variables = {}) {
    try {
      commit(types.GET_CALENDAR_EVENT_BEGIN);
      const {
        data: {
          data: {
            store: {
              calendarEvents
            }
          }
        }
      } = await gqlClient.query({
        query     : getCalendarEventsQuery,
        variables : variables
      });
      commit(types.GET_CALENDAR_EVENT_SUCCESS, calendarEvents);
    } catch (e) {
      commit(types.GET_CALENDAR_EVENT_ERROR, e);
    }
  },
  async createCalendarEvent({ commit }, variables) {
    try {
      commit(types.CREATE_CALENDAR_EVENT_BEGIN);
      const data = await api.calendarEvent.addCalendarEvent(variables);
      commit(types.CREATE_CALENDAR_EVENT_SUCCESS, data);
    } catch (e) {
      commit(types.CREATE_CALENDAR_EVENT_ERROR, e);
    }
  },
  async deleteCalendarEvent({ commit }, id) {
    commit(types.DELETE_CALENDAR_EVENT_BEGIN);
    try {
      await api.calendarEvent.deleteCalendarEvent(id);
      commit(types.DELETE_CALENDAR_EVENT_SUCCESS, id);

    } catch (e) {
      commit(types.DELETE_CALENDAR_EVENT_ERROR, e);
    }
  },
  async updateCalendarEvent({ commit }, { id,data }) {
    try {
      commit(types.UPDATE_CALENDAR_EVENT_BEGIN);
      const { data:updateData }= await api.calendarEvent.update(id,data);
      commit(types.UPDATE_CALENDAR_EVENT_SUCCESS, updateData);
    } catch (e) {
      commit(types.UPDATE_CALENDAR_EVENT_ERROR, e);
    }
  },
};

export default actions;